export enum MainTabs {
  SurveyEditor,
  HiddenVariables,
  Blocks,
  FullPreview,
  Sources,
  Translations,
  Settings
}
